import { memo } from 'react';

import { type IconComponent, Link2Icon, Link2OffIcon, LinkIcon, UnlinkIcon } from '@air/design-icons';

import { NotificationIconBadge } from '~/components/AirNotifications/components/NotificationIconBadge';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

export type NotificationShareLinkIconProps = {
  isBroken?: boolean;
};

const SHARE_LINK_ICON_BY_UI: Record<'legacy' | 'ui2026', Record<'broken' | 'ok', IconComponent>> = {
  legacy: { broken: UnlinkIcon, ok: LinkIcon },
  ui2026: { broken: Link2OffIcon, ok: Link2Icon },
};

export const NotificationShareLinkIcon = memo(({ isBroken }: NotificationShareLinkIconProps) => {
  const { ui2026 } = useTemporaryFeatureFlags();
  const icon = SHARE_LINK_ICON_BY_UI[ui2026 ? 'ui2026' : 'legacy'][isBroken ? 'broken' : 'ok'];

  return (
    <NotificationIconBadge
      data-testid="NOTIFICATION_SHARE_LINK_ICON"
      icon={icon}
      textClassName={isBroken ? 'ads:text-icon-error text-flamingo-700' : 'ads:text-icon-subtle text-pigeon-400'}
    />
  );
});

NotificationShareLinkIcon.displayName = 'NotificationShareLinkIcon';
